<template>
    <div class="next-product-form">
        <div class="next-product-form__container">
            <h1 class="next-product-form__title">What else are you interested&nbsp;in?</h1>
            <div class="next-product-form__selection-wrapper">
                <a
                    v-for="(topic, slug) in topics"
                    :key="slug"
                    @click.prevent="linkClicked(topic)"
                    href="javascript:void(0);">
                    <div class="next-product-form__section-element">
                        <p v-html="topic.text"></p>
                        <img :src="topic.img" alt="" />
                    </div>
                </a>
            </div>
            <a
                href="javascript:void(0);"
                class="next-product-form__not-interested-link"
                @click.prevent="noThanksLinkClicked()">
                I’m not interested in these topics
            </a>
        </div>
    </div>
</template>

<script>
import { iosview } from '../iosview';

export default {
    computed: {
        topics() {
            return window.App.topics;
        },
    },
    methods: {
        linkClicked(topic) {
            window.ipse.dispatch({
                action: 'button_clicked',
                data_event: {
                    page: 'topics',
                    button: 'topic',
                    product: topic.slug,
                },
            });

            if (window.App.isIosPwa) {
                iosview.topicsLinkClicked(topic);
            } else {
                window.location.href = topic.upsell_data.upsell_url;
            }
        },
        noThanksLinkClicked() {
            window.ipse.dispatch({
                action: 'no_thanks_upsell_clicked',
                data_event: {
                    page: 'topics',
                },
            });

            window.location.href = window.App.no_thanks_url;
        },
    },
};
</script>
